// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalChip_chip__ynjVH {
  border-radius: 12px !important;
  height: 26px !important;
  font-weight: 500 !important;
  line-height: 10px !important;
  padding: 8px 12px !important;
  overflow: visible !important;
}

/* Default */
.GlobalChip_default__B-5QT {
  background-color: var(--disabled-color) !important;
  color: var(--new-primary-color) !important;
}

/* Primary */
.GlobalChip_primary__lDZjt {
  background-color: var(--light-info) !important;
  color: var(--color-primary) !important;
}

/* Success */
.GlobalChip_success__owf60 {
  background-color: var(--green-bgChip-color) !important;
  color: var(--textChip-green-color) !important;
}

/* Warning */
.GlobalChip_warning__A09NX {
  background-color: var(--yellow-bgChip-color) !important;
  color: var(--textChip-yellow-color) !important;
}

/* Error */
.GlobalChip_error__ke\\+xH {
  background-color: var(--pending-bg-color) !important;
  color: var(--error-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/shared/utils/GlobalChip.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA,YAAY;AACZ;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,oDAAoD;EACpD,oCAAoC;AACtC","sourcesContent":[".chip {\n  border-radius: 12px !important;\n  height: 26px !important;\n  font-weight: 500 !important;\n  line-height: 10px !important;\n  padding: 8px 12px !important;\n  overflow: visible !important;\n}\n\n/* Default */\n.default {\n  background-color: var(--disabled-color) !important;\n  color: var(--new-primary-color) !important;\n}\n\n/* Primary */\n.primary {\n  background-color: var(--light-info) !important;\n  color: var(--color-primary) !important;\n}\n\n/* Success */\n.success {\n  background-color: var(--green-bgChip-color) !important;\n  color: var(--textChip-green-color) !important;\n}\n\n/* Warning */\n.warning {\n  background-color: var(--yellow-bgChip-color) !important;\n  color: var(--textChip-yellow-color) !important;\n}\n\n/* Error */\n.error {\n  background-color: var(--pending-bg-color) !important;\n  color: var(--error-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `GlobalChip_chip__ynjVH`,
	"default": `GlobalChip_default__B-5QT`,
	"primary": `GlobalChip_primary__lDZjt`,
	"success": `GlobalChip_success__owf60`,
	"warning": `GlobalChip_warning__A09NX`,
	"error": `GlobalChip_error__ke+xH`
};
export default ___CSS_LOADER_EXPORT___;
